import { API_HOST } from 'src/redux/constants';

const AI_BASE = `${API_HOST}/ai`;

export const AI_PROMPT_TEMPLATES_URL = `${AI_BASE}/prompt-templates/`;

// The trailing slash is required: /ai/prompt redirects and a POST loses its body.
export const AI_PROMPT_URL = `${AI_BASE}/prompt/`;

export const AI_PROMPT_STATUS_URL = `${AI_BASE}/prompt/status/`;

export const AI_POLL_INTERVAL_START_MS = 1000;

export const AI_POLL_INTERVAL_MAX_MS = 5000;

export const AI_POLL_BACKOFF = 1.5;

export const AI_POLL_TIMEOUT_MS = 100000;

export const AI_QUOTA_LOW_RATIO = 0.2;
